import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UtilityPageLayout from "../component/layout/UtilityPageLayout";
import { useGetStaffDetailsQuery } from "../../../service/referral-service";
import { useConfigLayout } from "../../../hooks/useConfigLayout";
import styles from './ReferralSystem.module.scss';
import { formatDateTime } from "../../admin/bulk-purchase/utils";
import { formatCurrency } from "../../../utils";
import RegisterUserTable from "./components/RegisterUserTable";
import { Range } from "react-date-range";
import Button from "../../../common/components/xepp/button/Button";
import CommonLoadingSpinner from "../../../common/components/loading-spinner/CommonLoadingSpinnerForPage";

const createInitials = (name: string | undefined) => {
    if (!name) return '';
    const parts = name.trim().split(/\s+/);
    const first = parts[0]?.charAt(0) ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
}

const StaffDetailsPage = () => {
    const { id } = useParams<{ id: string }>();
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState<string|undefined>("");
    const [fromDate, setFromDate] = useState<Date|undefined>();
    const [toDate, setToDate] = useState<Date|undefined>();

 const toStartOfDay = (date: Date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}T00:00:00`;
    };

    const toEndOfDay = (date: Date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}T23:59:59`;
    };


    const { data, isLoading, isFetching, isError, refetch } = useGetStaffDetailsQuery({
        page, pageSize: 10, StaffReferralId: id!, search: search ? search : undefined, fromDate: fromDate? toStartOfDay(fromDate): undefined, toDate: toDate ? toEndOfDay(toDate) : undefined
    }
    );
    const { updateLayout } = useConfigLayout();



    useEffect(() => {
        updateLayout({
            showBreadCrumb: false,
            pageTitle: (
                <span>
                    <span style={{ color: '#171717' }}>Referral System</span>
                    {' / '}
                    <span style={{ color: '#17171750' }}>Staff Details</span>
                </span>
            )
        });

        return () => {
            updateLayout({ pageTitle: null, showBreadCrumb: true });
        };
    }, [data?.staff?.fullName]);

    
if ((isLoading || !data) && !isError) return (
        <UtilityPageLayout title="">
            <CommonLoadingSpinner loading={true}>{null}</CommonLoadingSpinner>
        </UtilityPageLayout>
    ); 
    if (isError) return (
        <UtilityPageLayout title="">
            <div className={styles.errorContainer}>
                
                <p className={styles.error}>Something went wrong while loading staff details.</p>
                <Button text="Try again" className={styles.btn} onClick={refetch} />
            </div>
        </UtilityPageLayout>
    );

    

    return (
        <UtilityPageLayout title="">
            <div className={styles.staffDetailsPageContainer}>
                <div className={styles.staffDetailsContainer}>
                    <div className={styles.staffHeaderContainer}>
                        <div className={styles.nameContainer}>
                            {/* //name */}
                            <div className={styles.initialsContainer}>
                                {createInitials(data?.staff?.fullName)}
                            </div>
                            <span className={styles.name}> {data?.staff?.fullName} </span>
                        </div>
                        <div className={styles.dateContainer}>
                            <span className={styles.label}>Date Joined</span>
                            <span className={styles.value}>{formatDateTime(data?.staff?.created)}</span>
                        </div>
                    </div>
                    <div className={styles.staffInfoDataContainer}>
                        <div className={styles.infoContainer}>
                            <span className={styles.label}> Email address </span>
                            <span className={styles.value}> {data?.staff?.email}</span>
                        </div>
                        <div className={styles.infoContainer}>
                            <span className={styles.label}> Staff ID </span>
                            <span className={styles.value}> {data?.staff?.staffId}</span>
                        </div>
                        <div className={styles.infoContainer}>
                            <span className={styles.label}> Referral Code </span>
                            <span className={styles.value}> {data?.staff?.referralCode}</span>
                        </div>
                        <div className={styles.infoContainer}>
                            <span className={styles.label}> Sign Up Count </span>
                            <span className={styles.value}> {data?.staff?.numberOfRegisterReferrals}</span>
                        </div>
                        <div className={styles.infoContainer}>
                            <span className={styles.label}> Referral Transaction </span>
                            <span className={styles.value}> {formatCurrency(data?.staff?.totalRevenue ?? 0)}</span>
                        </div>
                    </div>
                </div>
                {/* table */}
                <RegisterUserTable registerUsers={data?.registerUsers} isFetching={isFetching} isLoading={isLoading} 
                page={page} onPageChange={setPage} search={search} onSearchChange={(val) => {setSearch(val); setPage(1)}} fromDate={fromDate} toDate={toDate} onDateFilterChange={(from, to) => {setFromDate(from); setToDate(to); setPage(1)}} 
                onDateFilterReset={() => {setFromDate(undefined); setToDate(undefined); setPage(1)}} />
                

            </div>
        </UtilityPageLayout>
    );
};

export default StaffDetailsPage;
